import { useEffect, useState } from "react"

const useBreakpoint = () => {
  const [device, setDevice] = useState("")

  useEffect(() => {
    const handler = () => {
      setDevice(window.innerWidth < 992 ? "m" : "d")
    }
    handler()
    window.addEventListener("resize", handler)
    return () => window.removeEventListener("resize", handler)
  }, [])

  return {
    isMobile: device === "m",
    isDesktop: device === "d",
    isUnknown: device === "",
  }
}

export default useBreakpoint
